import type { DevelopmentScenario } from "../types";

export interface DevelopmentMetrics {
  oneBrUnits: number;
  twoBrUnits: number;
  residentialGross: number;
  retailGross: number;
  otherIncome: number;
  grossPotentialRevenue: number;
  effectiveGrossIncome: number;
  operatingExpenses: number;
  noi: number;
  stabilizedValue: number;
  costMid: number;
  yieldOnCost: number;
  valueCostGap: number;
  valueToCost: number;
  parkingSpaces: number;
}

export function calcDevelopmentScenario(s: DevelopmentScenario): DevelopmentMetrics {
  const oneBrUnits = Math.round(s.units * s.oneBrPct);
  const twoBrUnits = s.units - oneBrUnits;
  const residentialGross = (oneBrUnits * s.oneBrRent + twoBrUnits * s.twoBrRent) * 12;
  const retailGross = s.retailSf * s.retailRentPsf;
  const otherIncome = s.units * s.otherIncomePerUnitMonthly * 12;
  const grossPotentialRevenue = residentialGross + retailGross + otherIncome;
  const effectiveGrossIncome = grossPotentialRevenue * (1 - s.vacancyPct);
  const operatingExpenses = effectiveGrossIncome * s.expensePct;
  const noi = effectiveGrossIncome - operatingExpenses;
  const stabilizedValue = s.exitCap > 0 ? noi / s.exitCap : 0;
  const costMid = (s.costLow + s.costHigh) / 2;
  return {
    oneBrUnits,
    twoBrUnits,
    residentialGross,
    retailGross,
    otherIncome,
    grossPotentialRevenue,
    effectiveGrossIncome,
    operatingExpenses,
    noi,
    stabilizedValue,
    costMid,
    yieldOnCost: costMid > 0 ? noi / costMid : 0,
    valueCostGap: stabilizedValue - costMid,
    valueToCost: costMid > 0 ? stabilizedValue / costMid : 0,
    parkingSpaces: Math.round(s.units * s.parkingRatio),
  };
}
